module.exports = require("lodash.map");